fragment Import2StatusFragment on Import2Import {
    originId
    crmOption {
        type
        label
    }
    import2Status
    importStatus
    externalImportId
    redirectUrl
    errors
    startTime
    endTime
    reviewRequested
    reviewApproved
    initiatingUser {
        id
        name
    }
}
